import { FaPaperclip } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";

const DropdownItemArquivoAgendamento = ({ notif, onClick }) => {
    const info = notif.atendimento_info;
    if (!info) return null;

    let dataFormatada = notif.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
            try {
                dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
            } catch (e) {}
    }

    return (
        <DropdownItemBase
            icon={<FaPaperclip />}
            text="text-info"
            titulo="Novo Arquivo"
            descricao={
                <>
                    Paciente: <strong>{info.beneficiario_nome}</strong>
                </>
            }
            subDescricao={`Programa: ${info.programa_nome}`}
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemArquivoAgendamento;
